import React from 'react';

import {colorIncidentStatus} from 'shared/lib/colors';
import {getServerIncidentStatusLabel} from 'features/server/lib/serverIncidentHelper';
import StatusBadge from 'shared/ui/Status/StatusBadge';

interface IServerIncidentStatusBadgeProps {
    isOpen: boolean,
    className?: string,
}

const ServerIncidentStatusBadge: React.FC<IServerIncidentStatusBadgeProps> = ({isOpen, className}) => (
    <StatusBadge
        color={colorIncidentStatus(!isOpen)}
        label={getServerIncidentStatusLabel(isOpen)}
        className={className}
    />
);

export default ServerIncidentStatusBadge;
